
















import { Component, Vue } from 'vue-property-decorator'
import { ITutorialSlide } from '@/components/Tutorial.vue'

@Component({
  components: {
    Tutorial: require('@/components/Tutorial').default
  }
})
export default class TagTransformer extends Vue {
  tutorialSlides: ITutorialSlide[] = [
    {
      html: 'With the Track Editor you can quickly find exactly the tracks you want and then you can edit the results. If you have a lot of track tags to change, this is the tool to use.<br>You can change your tracks in lots of ways here, like changing your titles to all uppercase, deleting cue points or merging fields together.<br><br>The tutorial shows a practical example of how to use the Track Editor.'
    },
    {
      image: 'trackeditor2.png',
      html: `You start by creating rules to find the tracks you want to change. If you want to change something in all tracks, just leave the rules empty.<br><br>In this tutorial, I'm going to remove the comments from all my Drum & Bass tracks that are 174 BPM.<br><br>The image above shows two rules. With these two rules I'm targeting tracks at 174 BPM that have a comment.<br>You can add any number of rules here and that way you can target almost anything.<br><br>Rekordcloud will show you a few previews of the tracks it finds so you can check if they are the right ones`
    },
    {
      image: 'trackeditor3.png',
      html: `There are many transformers to choose from and new transformers are made upon request.<br><br>In this case, I'm choosing "Empty field" because I want to remove comments from these tracks.`
    },
    {
      image: 'trackeditor4.png',
      html: `Now the last step. I've chosen the field "Comment" because that's the field I want to clear.<br><br>In the preview table, you'll see the tracks your rules are targeting and it shows that the new comment will be empty. I've selected a few tracks with comments that really aren't helpful. Now all I have to do is confirm and rekordcloud will update these tracks.<br><br>That's the end of the tutorial. The Track Editor can be extremely powerful once you get the hang of it!`
    }
  ]
}
